import {
  PieChart, Pie, Cell, Tooltip, ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid,
} from 'recharts';
import { campaignPerformanceData, sourceConversionData, deviceData } from '../../../mocks/dashboard';

const CustomTooltip = ({ active, payload }: any) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white border border-border rounded-xl p-3 shadow-hover text-[12px]">
      <p className="font-semibold text-charcoal-500">{payload[0].name}</p>
      <p style={{ color: payload[0].payload.color || '#D4AF37' }} className="font-medium">
        {payload[0].value}{payload[0].name?.includes('Oran') ? '%' : ''}
      </p>
    </div>
  );
};

export function CampaignPieChart() {
  return (
    <div className="bg-white rounded-xl2 shadow-card p-6">
      <h3 className="text-[16px] font-semibold text-charcoal-600 mb-1">Kampanya Performansı</h3>
      <p className="text-[12px] text-charcoal-300 mb-4">Trafik paylaşımı</p>
      <ResponsiveContainer width="100%" height={170}>
        <PieChart>
          <Pie data={campaignPerformanceData} cx="50%" cy="50%" innerRadius={50} outerRadius={75} paddingAngle={3} dataKey="value">
            {campaignPerformanceData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
        </PieChart>
      </ResponsiveContainer>
      <div className="space-y-2 mt-2">
        {campaignPerformanceData.map(item => (
          <div key={item.name} className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ backgroundColor: item.color }} />
              <span className="text-[12px] text-charcoal-400 truncate max-w-[120px]">{item.name}</span>
            </div>
            <span className="text-[12px] font-semibold text-charcoal-600">{item.value}%</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export function SourceConversionChart() {
  const data = sourceConversionData.map(s => ({ ...s, rate: parseFloat(s.rate.toFixed(1)) }));
  return (
    <div className="bg-white rounded-xl2 shadow-card p-6">
      <h3 className="text-[16px] font-semibold text-charcoal-600 mb-1">Kaynak Dönüşüm Oranı</h3>
      <p className="text-[12px] text-charcoal-300 mb-4">Kaynağa göre dönüşüm %</p>
      <ResponsiveContainer width="100%" height={200}>
        <BarChart layout="vertical" data={data} margin={{ top: 0, right: 20, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="convGrad" x1="0" y1="0" x2="1" y2="0">
              <stop offset="0%" stopColor="#D4AF37" />
              <stop offset="100%" stopColor="#E8C87C" />
            </linearGradient>
          </defs>
          <CartesianGrid horizontal={false} strokeDasharray="3 3" stroke="#F0EDE8" />
          <XAxis type="number" tick={{ fontSize: 11, fill: '#A0A0A0' }} axisLine={false} tickLine={false} unit="%" />
          <YAxis type="category" dataKey="source" tick={{ fontSize: 11, fill: '#A0A0A0' }} axisLine={false} tickLine={false} width={70} />
          <Tooltip formatter={(v: number) => [`${v}%`, 'Dönüşüm']} />
          <Bar dataKey="rate" name="Dönüşüm Oranı" fill="url(#convGrad)" radius={[0, 4, 4, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export function DeviceChart() {
  return (
    <div className="bg-white rounded-xl2 shadow-card p-6">
      <h3 className="text-[16px] font-semibold text-charcoal-600 mb-1">Cihaz Dağılımı</h3>
      <p className="text-[12px] text-charcoal-300 mb-4">Ziyaretçi cihaz türleri</p>
      <ResponsiveContainer width="100%" height={170}>
        <PieChart>
          <Pie data={deviceData} cx="50%" cy="50%" innerRadius={50} outerRadius={75} paddingAngle={3} dataKey="value">
            {deviceData.map((entry, index) => (
              <Cell key={`dc-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
        </PieChart>
      </ResponsiveContainer>
      <div className="space-y-2.5 mt-3">
        {deviceData.map(item => (
          <div key={item.name} className="flex items-center gap-2">
            <span className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ backgroundColor: item.color }} />
            <div className="flex-1 h-1.5 rounded-full bg-[#F0EDE8] overflow-hidden">
              <div className="h-full rounded-full" style={{ width: `${item.value}%`, backgroundColor: item.color }} />
            </div>
            <span className="text-[12px] font-semibold text-charcoal-600 w-8 text-right">{item.value}%</span>
            <span className="text-[12px] text-charcoal-400 w-16">{item.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
